class If_Variable_Changed {
    static path = 'logic/if-variable-changed';

    constructor(mutator){
        this.addInput("Source", "pinned");
        this.addOutput("True/False", "boolean");
        this.bgcolor = '#9fe2fc';
        this.title = 'If Data Changed';
        this.desc = 'Detect is the triggered object\'s specified variable was updated or not.';
        this.properties = {selected: '', options: [], xTypes: {}, parentProperties: {}};
    }

    onConnectionsChange(type) {
        if(type === 1) { //LiteGraph.INPUT
            let parent_node = this.getParentNode();
            this.widgets = [];
            this.properties.options = [];
            this.properties.xTypes = {};

            if (!parent_node) {
                this.title = 'If Data Changed'
                this.properties.parentProperties = {};
                this.properties.xTypes = {}
                return;
            }

            let properties = parent_node.properties.modelProperties && parent_node.properties.modelProperties.properties && Object.keys(parent_node.properties.modelProperties.properties).length > 0 ? parent_node.properties.modelProperties.properties : false;
            if (properties) {
                this.properties.parentProperties = parent_node.properties.modelProperties || {}
                Object.keys(properties).forEach((prop) => {
                    this.properties.options.push(prop);
                    this.properties.xTypes[prop] = properties[prop].type;
                });
            }

            this.setupPropertySelectionWidget();
        }
    }

    setupPropertySelectionWidget() {
        this.addWidget("combo","",this.properties.selected,(v) => {
            this.properties.selected = v;
            if(v !== '') {
                this.title = 'If ' + v.replace(/_/g, ' ') + ' Changed';
            } else {
                this.title = 'If Data Changed'
            }
            this.triggerSlot(0, v);
        },{ property: "selected", values: this.properties.options } );
    }
}

module.exports = If_Variable_Changed
